import React, { useState, useEffect } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { headerTyps } from '../../utils/forecastStaticData';
import ForecastStateRows from './ForecastStateRows';
const useStyles = makeStyles({
    table: {
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)",
            align: 'center'
        }
    }
});



const ForecastStateTable = ({ headerRows, data, tableRef }) => {
    const classes = useStyles();
    const [tableWidth, setTableWidth] = useState(420);
    const [emptyColSpan, setEmptyColSpan] = useState(12);

    useEffect(() => {
        if (headerRows.length > 0) {
            const rowsWidth = (headerRows.length * 320) + 420;
            const colSpan = (headerRows.length * 4) + 2;
            //console.log(colSpan, 'colSpan')
            setTableWidth(rowsWidth);
            setEmptyColSpan(colSpan);
        }
    }, [headerRows])


    if (!headerRows || !data) {
        return null;
    }



    return (
        <Paper sx={{ overflow: 'auto', my: 1 }}>
            <TableContainer sx={{ width: "100%", display: "table", tableLayout: "fixed" }} >
                <Table size="small" className={classes.table} ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" rowSpan={2}>본부</TableCell>
                            <TableCell align="center" rowSpan={2}>팀</TableCell>
                            {headerRows.map((header) => (
                                <TableCell colSpan={4} align="center" key={header.val}>영업 포캐스팅-{header.name}</TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            {headerRows.map((header) => {
                                return headerTyps.map((typ, index) => (
                                    <TableCell align="center" key={index}>{typ.name}</TableCell>
                                ))
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(data) && data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={emptyColSpan} align="center">데이터가 없습니다.</TableCell>
                            </TableRow>
                        ) : (
                            <ForecastStateRows headerRows={headerRows} data={data} />
                        )}

                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default ForecastStateTable